import { addInfoBanner } from '../../mappers/infoBanner';
export var useInfoBanner = function useInfoBanner(code) {
  var TopBanner = null;
  var BottomBanner = null;
  var banners = addInfoBanner(code);
  if (!banners.length) {
    return {
      TopBanner: TopBanner,
      BottomBanner: BottomBanner
    };
  }
  banners.forEach(function (_ref) {
    var component = _ref.component,
      type = _ref.type;
    if (type === 'top') {
      TopBanner = component;
    } else {
      BottomBanner = component;
    }
  });
  return {
    TopBanner: TopBanner,
    BottomBanner: BottomBanner
  };
};